const selectors = {
  link: '[data-top-link]',
  navHiddenButton: '[data-nav-hidden-button]',
  wrapper: '[data-header-wrapper]',
  stagger: '[data-stagger]',
  staggerPair: '[data-stagger-first]',
  staggerAfter: '[data-stagger-second]',
  focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
};

const classes = {
  isVisible: 'is-visible',
  meganavVisible: 'meganav--visible',
  meganavIsTransitioning: 'meganav--is-transitioning',
};

const attributes = {
  scrollLocked: 'data-scroll-locked',
};

if (!customElements.get('hover-disclosure')) {
  customElements.define(
    'hover-disclosure',

    class HoverDisclosure extends HTMLElement {
      constructor() {
        super();

        this.wrapper = this.closest(selectors.wrapper);
        this.link = this.querySelector(selectors.link);
        this.navHiddenButton = this.querySelector(selectors.navHiddenButton);
        this.key = this.link.getAttribute('aria-controls');
        this.grandparent = this.classList.contains('grandparent');
        this.disclosure = document.getElementById(this.key);
        this.transitionTimeout = 0;
        this.search = document.querySelector('header-search-popdown');
        this.header = document.querySelector('header');

        const isAndroid = /Android/i.test(navigator.userAgent) && !/Windows/i.test(navigator.userAgent);

        if (!isAndroid) window.addEventListener('resize', () => this.hideDisclosure());
        screen.orientation?.addEventListener?.('change', () => this.hideDisclosure());
        window.addEventListener('orientationchange', () => this.hideDisclosure());
      }

      connectedCallback() {
        this.connectHoverToggle();
        this.staggerChildAnimations();

        this.addEventListener('theme:disclosure:show', (evt) => {
          this.showDisclosure(evt);
        });
        this.addEventListener('theme:disclosure:hide', (evt) => {
          this.hideDisclosure(evt);
        });
      }

      showDisclosure(e) {
        if (e && e.type && e.type === 'mouseenter') {
          this.wrapper.classList.add(classes.meganavIsTransitioning);
        }
        this.search.close();

        if (this.grandparent) {
          this.wrapper.classList.add(classes.meganavVisible);
        } else {
          this.wrapper.classList.remove(classes.meganavVisible);
        }

        this.link.setAttribute('aria-expanded', true);
        this.navHiddenButton.setAttribute('aria-expanded', true);
        this.classList.add(classes.isVisible);
        this.disclosure.classList.add(classes.isVisible);
        this.disclosure.setAttribute('aria-hidden', false);

        if (this.transitionTimeout) {
          clearTimeout(this.transitionTimeout);
        }

        this.transitionTimeout = setTimeout(() => {
          this.wrapper.classList.remove(classes.meganavIsTransitioning);
        }, 200);

        if (!document.documentElement.hasAttribute(attributes.scrollLocked)) {
          document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
        }
      }

      hideDisclosure() {
        this.classList.remove(classes.isVisible);
        this.disclosure.classList.remove(classes.isVisible);
        this.disclosure.setAttribute('aria-hidden', true);
        this.link.setAttribute('aria-expanded', false);
        this.navHiddenButton.setAttribute('aria-expanded', false);
        this.wrapper.classList.remove(classes.meganavVisible, classes.meganavIsTransitioning);

        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));

        if (this.header.classList.contains('not-transparent-bg')) {
          this.header.classList.remove('not-transparent-bg');
        }
      }

      staggerChildAnimations() {
        const simple = this.querySelectorAll(selectors.stagger);
        let step = 50;
        simple.forEach((el, index) => {
          el.style.transitionDelay = `${index * step + 10}ms`;
          step *= 0.95;
        });

        const pairs = this.querySelectorAll(selectors.staggerPair);
        pairs.forEach((child, i) => {
          const d1 = i * 100;
          child.style.transitionDelay = `${d1}ms`;
          child.parentElement.querySelectorAll(selectors.staggerAfter).forEach((grandchild, i2) => {
            const di1 = i2 + 1;
            const d2 = di1 * 20;
            grandchild.style.transitionDelay = `${d1 + d2}ms`;
          });
        });
      }

      connectHoverToggle() {
        this.addEventListener('mouseenter', (e) => this.showDisclosure(e));
        this.navHiddenButton.addEventListener('click', (e) => {
          if (this.classList.contains(classes.isVisible)) this.hideDisclosure();
          else this.showDisclosure(e);
        });

        this.addEventListener('mouseleave', () => this.hideDisclosure());
        this.addEventListener('focusout', (e) => {
          const inMenu = this.contains(e.relatedTarget);
          if (inMenu) return;
          this.hideDisclosure();
        });
        this.addEventListener('keyup', (evt) => {
          if (evt.code !== 'Escape') return;
          this.hideDisclosure();
        });
      }
    }
  );
}
